import type { InvoiceStatus, PaymentStatus } from '@/types';

/**
 * Geteilte Labels/Badge-Klassen für Rechnungs-Status — Muster
 * bauvorhabenStatus.ts. Farbsprache: neu eingegangen cyan (klar
 * unterscheidbar von 'erfasst' grau, Signal „aus dem Mail-Eingang“),
 * erfasst grau, formal geprüft amber, freigegeben grün, Korrektur
 * orange, abgelehnt rot, Lexware blau.
 */
export const invoiceStatusLabels: Record<InvoiceStatus, string> = {
  neu_eingegangen: 'Neu eingegangen',
  erfasst: 'Erfasst',
  formal_geprueft: 'Formal geprüft',
  freigegeben: 'Freigegeben',
  korrektur_erforderlich: 'Korrektur erforderlich',
  abgelehnt: 'Abgelehnt',
  an_lexware_uebergeben: 'An Lexware übergeben',
};

export const invoiceStatusBadgeClasses: Record<InvoiceStatus, string> = {
  neu_eingegangen: 'bg-cyan-100 text-cyan-800',
  erfasst: 'bg-gray-100 text-gray-700',
  formal_geprueft: 'bg-amber-100 text-amber-800',
  freigegeben: 'bg-green-100 text-green-800',
  korrektur_erforderlich: 'bg-orange-100 text-orange-800',
  abgelehnt: 'bg-red-100 text-red-800',
  an_lexware_uebergeben: 'bg-blue-100 text-blue-800',
};

export const paymentStatusLabels: Record<PaymentStatus, string> = {
  offen: 'Offen',
  bezahlt: 'Bezahlt',
};

/** Aktion → deutsche Beschriftung für Status-Timeline. */
export const transitionActionLabels: Record<string, string> = {
  email_received: 'E-Mail eingegangen (automatisch erfasst)',
  create: 'Erfasst',
  formal_check: 'Formal geprüft',
  approve: 'Freigegeben',
  request_correction: 'Korrektur angefordert',
  reject: 'Abgelehnt',
  reopen_review: 'Erneut zur Prüfung',
  mark_exported: 'An Lexware übergeben',
  reopen_lexware: 'Lexware-Übergabe zurückgenommen',
  mark_paid: 'Als bezahlt markiert',
  mark_unpaid: 'Bezahlt zurückgenommen',
};